

import Vue from 'vue'

import VueRouter from 'vue-router'
import App from './App.vue'
import router from './router/index'
import store from "./store";

import '@/assets/css/fonts/iconfont.css'



import NoData from "@/components/common/no-data.vue"
Vue.component('no-data',NoData)


import glConfig from "@/utils/config.js"
Vue.prototype.glConfig = glConfig












import 'element-ui/lib/theme-chalk/index.css'
import Element from 'element-ui'
Vue.use(Element);

import requestApi from "@/api/request"
Vue.prototype.glRequest = requestApi


import './assets/css/common.css'
import './assets/css/reset-vux.less'

import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'

Vue.use(ConfirmPlugin)

Vue.use(VueRouter)

router.afterEach((to,from,next) =>{
window.scrollTo(0,0);
});



Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
el: '#app',
router,
store,
render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js